<template>
  <div>
    <div v-for="widget in widgets" :key="widget.img" class="widget-card widget-amo mb-4">
      <div v-if="widget.connected" class="widget-card__title-row">
        <img :class="widget.classes" :src="widget.img" alt="integration" loading="lazy" />
        <h6 class="dashboard-card__title mx-3">
          {{ $t(widget.description) }}
        </h6>

        <div>
          <router-link
            :to="{ name: 'integrations.tabs.auth' }"
            class="dashboard-card__button ivu-btn ivu-btn-primary ivu-btn-large"
          >
            <span> {{ $t('integrations.page.button.settings') }} </span>
          </router-link>
        </div>
      </div>
      <div v-if="widget.connected" class="widget-card__body">
        <div>
          <div class="mt-2 d-flex flex-row-end">
            <icon size="24" type="ios-alert-outline" class="mr-1" />
            <div>
              {{ $t('integrations.page.connect') }}

              <span class="text-bold">{{ auth_data.amo_login }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        :class="
          widget.disabled ? 'disabled-block widget-card__title-row' : 'widget-card__title-row'
        "
      >
        <img :class="widget.classes" :src="widget.img" alt="integration" loading="lazy" />
        <h6 class="dashboard-card__title mx-3">
          {{ $t(widget.description) }}
        </h6>

        <div>
          <tooltip
            v-if="widget.disabled"
            class="ml-3"
            placement="top"
            min-width="200"
            max-width="200"
            theme="light"
            :transfer="true"
            :content="$t('integrations.page.tooltip.other_integration')"
          >
            <a class="px-3 disabled ivu-btn ivu-btn-large">
              <span> {{ $t('integrations.page.button.connect') }} </span></a
            >
          </tooltip>
          <a v-else :href="widget.link" class="px-3 ivu-btn-success ivu-btn ivu-btn-large">
            <span> {{ $t('integrations.page.button.connect') }} </span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      auth_data: {
        type: Object,
        default: () => {}
      }
    },
    data: () => ({
      widgets: []
    }),
    computed: {
      ...mapGetters('core/auth', ['user'])
    },

    // watch: {
    //   '$i18n.locale': function (locale) {
    //     if (locale === 'ru') {
    //       this.img = '/img/icons/widgets/amo.svg';
    //       this.classes = 'logo-crm logo-crm--amo';
    //       this.link = this.auth_data?.auth['amocrm.ru'];
    //     } else if (locale === 'en') {
    //       this.img = '/img/icons/widgets/kommo.svg';
    //       this.classes = 'logo-crm logo-crm--kommo';
    //       this.link = this.auth_data?.auth['amocrm.com'];
    //     }
    //   }
    // },

    created() {
      const { status, base_domain, auth } = this.auth_data;
      const isAmoConnected = status === 'connected' && base_domain.includes('amocrm.ru');
      const isKommoConnected =
        status === 'connected' &&
        (base_domain.includes('amocrm.com') || base_domain.includes('kommo.com'));

      this.widgets = [
        {
          img: '/img/icons/widgets/amo.svg',
          classes: 'logo-crm logo-crm--amo',
          link: auth['amocrm.ru'],
          description: 'integrations.page.amo_info',
          connected: isAmoConnected,
          disabled: isKommoConnected
        },
        {
          img: '/img/icons/widgets/kommo.svg',
          classes: 'logo-crm logo-crm--kommo',
          link: auth['kommo.com'],
          description: 'integrations.page.kommo_info',
          connected: isKommoConnected,
          disabled: isAmoConnected
        }
      ];

      // if (locale === 'ru') {
      //   this.img = '/img/icons/widgets/amo.svg';
      //   this.classes = 'logo-crm logo-crm--amo';
      //   this.link = this.auth_data?.auth['amocrm.ru'];
      // } else if (locale === 'en') {
      //   this.img = '/img/icons/widgets/kommo.svg';
      //   this.classes = 'logo-crm logo-crm--kommo';
      //   this.link = this.auth_data?.auth['amocrm.com'];
      // }
    }
  };
</script>
